import React, { useEffect, useCallback, useRef } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import HomeVisitRecordForm from '../../components/Records/HomeVisit/HomeVisitRecordForm';
import * as RecordActions from '../../actions/Records/actions';
import * as UserActions from '../../actions/User/actions';
import { RootState } from '../../store/configureStore';
import Loading from '../../components/common/Loading';
import { HomeVisitRecord } from '../../constants/Records';

interface RouteParams {
  institutionId: string;
  userId: string;
}

interface StateProps {
  institution: any;
  userListData: any[];
  homevisit: any;
}

interface DispatchProps {
  recordActions: typeof RecordActions;
  userActions: typeof UserActions;
}

type Props = StateProps & DispatchProps;

const HomeVisitRecordCreateContainer: React.FC<Props> = ({
  institution,
  userListData,
  homevisit,
  recordActions,
  userActions,
}) => {
  const { institutionId, userId } = useParams<RouteParams>();
  const userFetchedRef = useRef(false);

  const user = userListData.find((u: any) => u.user_id === userId);

  useEffect(() => {
    if (userListData.length === 0 && !userFetchedRef.current && institutionId) {
      userFetchedRef.current = true;
      userActions.getUsersWithUniqueId(institutionId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [institutionId, userListData.length]);

  const handleCreate = useCallback(
    (uniqueId: string, data: Partial<HomeVisitRecord>) => {
      recordActions.createHomeVisitRecord(uniqueId, data);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const handleResetFlags = useCallback(() => {
    recordActions.resetHomeVisitFlags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!user) {
    return <Loading />;
  }

  return (
    <HomeVisitRecordForm
      institutionId={institutionId}
      institutionName={institution?.institution_name || ''}
      userId={userId}
      userName={user.user_name}
      uniqueId={user.unique_id || ''}
      currentRecord={null}
      isEdit={false}
      executing={homevisit.executing}
      created={homevisit.created}
      updated={homevisit.updated}
      onFetchRecord={() => {}}
      onCreate={handleCreate}
      onUpdate={() => {}}
      onResetFlags={handleResetFlags}
    />
  );
};

function mapStateToProps(state: RootState): StateProps {
  return {
    institution: state.institution.institution,
    userListData: state.user.listData,
    homevisit: state.records.homevisit,
  };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
  return {
    recordActions: bindActionCreators(RecordActions, dispatch),
    userActions: bindActionCreators(UserActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeVisitRecordCreateContainer);
